import useAxios from "axios-hooks";
import React from "react";
import { withRouter } from "react-router-dom";
import { StyledForm } from "./AddUser";
import { API_URL } from "../../../config";
import axios from "axios";

const EditUser = (props) => {
  const [{ data: user, loading }, fetchSingleUser] = useAxios({
    url: `${API_URL}/getUser/${props.match.params.userEmail}`,
    method: "GET",
    withCredentials: true,
  });

  const updateUser = (data) =>
    axios({
      url: `${API_URL}/updateUser`,
      method: "PUT",
      withCredentials: true,
      data,
    });

  const deleteUser = (data) =>
    axios({
      url: `${API_URL}/deleteUser`,
      method: "POST",
      withCredentials: true,
      data,
    });

  if (loading) return "Loading";

  return (
    <EditForm
      user={user}
      courses={props.courses}
      updateUser={updateUser}
      deleteUser={deleteUser}
      fetchSingleUser={fetchSingleUser}
      fetchAllUsers={props.fetchAllUsers}
      history={props.history}
    />
  );
};

export default withRouter(EditUser);

class EditForm extends React.Component {
  state = {
    firstName: this.props.user.firstName,
    lastName: this.props.user.lastName,
    ownedCourses: [...this.props.user.ownedCourses],
    admin: this.props.user.admin,
  };
  handleCoursesChange = (e) => {
    // If its in the array, add it otherwise delete it

    const value = parseInt(e.target.value);
    let ownedCourses = this.state.ownedCourses;
    const index = ownedCourses.indexOf(value);

    if (index > -1) {
      ownedCourses.splice(index, 1);
    } else {
      ownedCourses.push(value);
    }

    this.setState({
      ownedCourses,
    });
  };
  handleChange = (e) => {
    let value = e.target.value;

    if (e.target.name === "admin") {
      value = parseInt(e.target.value);
    }
    this.setState({
      [e.target.name]: value,
    });
  };
  render() {
    return (
      <>
        <h1>Edit User Form</h1>
        <h3>Username: {this.props.user.email}</h3>
        <StyledForm>
          <label>
            First name
            <input
              type="text"
              name="firstName"
              value={this.state.firstName}
              onChange={this.handleChange}
            />
          </label>
          <label>
            Last name
            <input
              type="text"
              name="lastName"
              value={this.state.lastName}
              onChange={this.handleChange}
            />
          </label>
          <label>
            Which courses do they own?
            <div>
              {this.props.courses.map((course) => (
                <div key={course.id}>
                  <input
                    type="checkBox"
                    checked={this.state.ownedCourses.indexOf(course.id) > -1}
                    onChange={this.handleCoursesChange}
                    value={course.id}
                  />
                  {course.courseName}
                </div>
              ))}
            </div>
          </label>
          <label>
            Do they have administrative privilidges (be careful with this)?
            <div className="radioDiv">
              <input
                type="radio"
                name="admin"
                value={1}
                checked={this.state.admin === 1}
                onChange={this.handleChange}
              />
              Yes
            </div>
            <div className="radioDiv">
              <input
                type="radio"
                name="admin"
                value={0}
                checked={this.state.admin === 0}
                onChange={this.handleChange}
              />
              No
            </div>
          </label>
          <button
            onClick={(e) => {
              e.preventDefault();
              this.props
                .updateUser({
                  firstName: this.state.firstName,
                  lastName: this.state.lastName,
                  ownedCourses: this.state.ownedCourses,
                  previouslyOwnedCourses: this.props.user.ownedCourses,
                  admin: this.state.admin,
                  userId: this.props.user.id,
                })
                .then(() => {
                  alert("User has been updated");
                  this.props.fetchSingleUser();
                })
                .catch((err) => {
                  alert(err);
                });
            }}
          >
            Update User
          </button>
        </StyledForm>
        <button
          className="delete"
          onClick={() => {
            if (window.confirm("Are you sure you want to delete this user?")) {
              this.props
                .deleteUser({
                  email: this.props.user.email,
                })
                .then(() => {
                  alert("User has been deleted");
                  this.props.fetchAllUsers();
                  this.props.history.push("/admin/findUser");
                });
            }
          }}
        >
          Delete User
        </button>
      </>
    );
  }
}
